import React, {useState} from 'react';
import wrap from 'wraptile';
import classNames from 'classnames';
import {OnStringSetState} from '@pluto/@types';
import {UserValue} from '@pluto/users';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import ClearIcon from '@material-ui/icons/Clear';
import AssignDialog from './AssignDialog';
import {
    AssignDialogContainerProps,
    Assignee,
    AssignQCJob,
    UnassignQCJob,
} from '../../QCManagerTypes';
import {QCFilters} from '../../../QCFilters/QCFiltersType';
import './AssignDialogContainer.scss';

type SetOpen = (val: boolean) => void;

interface HandleUserAssign {
    id: string;
    assignedUser: Assignee;
    setAssignedUser: OnStringSetState;
    setOpen: SetOpen;
    assignQCJob: AssignQCJob;
    params: QCFilters;
}

interface HandleUserUnassign {
    id: string;
    setOpen: (value: boolean) => void;
    unassignQCJob: UnassignQCJob;
    params: QCFilters;
}

export const handleAssignOpen = wrap((setOpen: SetOpen) => {
    setOpen(true);
});

export const handleAssignClose = wrap((setOpen: SetOpen, setAssignedUser: OnStringSetState) => {
    setAssignedUser('');
    setOpen(false);
});

export const getIsAssigned = (assignee?: Assignee | null): boolean => {
    if (!assignee || !assignee.email)
        return false;
    
    return true;
};

export const openSingleAssigneeModal = wrap((setOpen: SetOpen, setAssignedUser: (value: UserValue) => void, assignee: UserValue) => {
    setAssignedUser(assignee);
    setOpen(true);
});

export const handleUserUnassign = wrap((handlers: HandleUserUnassign) => {
    const {
        id,
        setOpen,
        unassignQCJob,
        params,
    } = handlers;
    
    const body = [{
        id: Number(id),
        userId: null,
    }];
    
    unassignQCJob(body, params);
    setOpen(false);
});

export const handleUserAssign = wrap((handlers: HandleUserAssign) => {
    const {
        id,
        assignedUser,
        setOpen,
        assignQCJob,
        params,
        setAssignedUser,
    } = handlers;
    
    const body = [{
        userId: assignedUser.id,
        id: Number(id),
    }];
    
    setAssignedUser('');
    assignQCJob(body, params);
    setOpen(false);
});

export default function AssignDialogContainer(props: AssignDialogContainerProps) {
    const {
        data,
        id,
        handleSelectChangeAssign,
        setAssignedUser,
        assignQCJob,
        unassignQCJob,
        params,
        assignedUser,
        assignee,
    } = props;
    
    const [open, setOpen] = useState<boolean>(false);
    const assigneeName = assignee?.name;
    
    const onAssign = handleUserAssign({
        id,
        assignedUser,
        setOpen,
        assignQCJob,
        params,
        setAssignedUser,
    });
    
    const onUnassign = handleUserUnassign({
        id,
        setOpen,
        unassignQCJob,
        params,
    });
    
    return (
        <div>
            <div className="assignee-wrapper">
                <div className="assignee-name">
                    {assigneeName}
                </div>
                
                <div
                    className={classNames({
                        'control-icons': true,
                        'single-pencil': !assigneeName,
                    })}
                >
                    <BorderColorIcon
                        fontSize="small"
                        onClick={openSingleAssigneeModal(setOpen, setAssignedUser, assignee)}
                    />
                    {
                        assigneeName
                        && (
                            <ClearIcon
                                fontSize="small"
                                onClick={onUnassign}
                            />
                        )
                    }
                </div>
            
            </div>
            <AssignDialog
                singleItemId={id}
                data={data}
                assignedUser={assignedUser}
                open={open}
                isAssigned={getIsAssigned(assignedUser)}
                handleAssignOpen={handleAssignOpen(setOpen)}
                handleAssignClose={handleAssignClose(setOpen, setAssignedUser)}
                handleSelectChangeAssign={handleSelectChangeAssign(setAssignedUser)}
                handleUserAssign={onAssign}
            />
        </div>
    );
}
